import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.factoringLoading"],
  loading => loading
);
